import { GlButton, GlForm, GlFormFields } from '@gitlab/ui';
import { formValidators } from '@gitlab/ui/src/utils';
import illustration from '@gitlab/svgs/dist/illustrations/empty-state/empty-service-desk-md.svg?url';
import csrf from '~/lib/utils/csrf';
import { s__ } from '~/locale';
import VerificationLayout from './verification_layout.vue';
import VerificationDivider from './verification_divider.vue';
import VerificationRecoverAccount from './verification_recover_account.vue';
export default {
    name: 'TotpCode',
    components: {
        GlButton,
        GlForm,
        GlFormFields,
        VerificationLayout,
        VerificationDivider,
        VerificationRecoverAccount
    },
    props: {
        path: {
            type: String,
            required: true
        },
        rememberMe: {
            type: String,
            required: true
        },
        rememberMeEnabled: {
            type: Boolean,
            required: true
        },
        webauthnEnabled: {
            type: Boolean,
            required: false,
            default: false
        },
        emailEnabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'switch-method'
    ],
    data () {
        return {
            values: {
                otpAttempt: ''
            }
        };
    },
    csrf,
    illustration,
    fields: {
        otpAttempt: {
            // Canonical GitLab 2FA field id so password managers recognise it for OTP autofill,
            // matching the long-standing HAML form. GlFormFields uses it for the input id and label.
            id: 'user_otp_attempt',
            label: s__('TwoFactorAuth|6-digit code'),
            validators: [
                formValidators.required(s__('TwoFactorAuth|One-time passcode is required.'))
            ],
            inputAttrs: {
                autocomplete: 'one-time-code',
                autofocus: true,
                'data-testid': 'two-fa-code-field',
                inputmode: 'numeric',
                name: 'user[otp_attempt]'
            }
        }
    }
};
